import AttachmentPermissionLevel from 'owa-service/lib/contract/AttachmentPermissionLevel';
import GetSharingInfoResponse from 'owa-service/lib/contract/GetSharingInfoResponse';

export function createAttachmentPermissionLevelsFromSharingInfo(
    sharingInformation: GetSharingInfoResponse
): AttachmentPermissionLevel[] {
    if (sharingInformation === null) {
        return null;
    }

    const supportedPermissions: AttachmentPermissionLevel[] = [];

    if (sharingInformation.CanShareInternally) {
        supportedPermissions.push(AttachmentPermissionLevel.Edit);
        supportedPermissions.push(AttachmentPermissionLevel.View);
    }

    if (sharingInformation.CanCreateOrganizationEditLink) {
        supportedPermissions.push(AttachmentPermissionLevel.OrganizationEdit);
    }

    if (sharingInformation.CanCreateOrganizationViewLink) {
        supportedPermissions.push(AttachmentPermissionLevel.OrganizationView);
    }

    if (sharingInformation.CanCreateAnonymousEditLink) {
        supportedPermissions.push(AttachmentPermissionLevel.AnonymousEdit);
    }

    if (sharingInformation.CanCreateAnonymousViewLink) {
        supportedPermissions.push(AttachmentPermissionLevel.AnonymousView);
    }

    if (supportedPermissions.length > 0) {
        return supportedPermissions;
    }

    return null;
}
